import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { ImageCropperComponent, ImageCroppedEvent, LoadedImage, ImageTransform } from 'ngx-image-cropper';
import { MaterialModule } from '../../material/material.module';
import { CommonModule } from '@angular/common';
import { isNullOrUndefined } from '@pineapplelab/util';
import { ToasterService } from '../../services/toaster/toaster.service';
import { UploadImageService } from '../../services/upload-image/upload-image.service';
import { SafeUrlPipe } from '../../pipes/safe-url/safe-url.pipe';
import { PipesModule } from '../../pipes/pipes.module';
import { ToasterTypeEnum } from '../../enums/toasterType.enum';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-upload-image',
  standalone: true,
  imports: [ImageCropperComponent, MaterialModule, CommonModule, SafeUrlPipe, PipesModule],
  providers: [ToasterService, UploadImageService],
  templateUrl: './upload-image.component.html',
  styleUrl: './upload-image.component.scss'
})
export class UploadImageComponent implements OnInit {
	imageChangedEvent: Event = null;
    croppedImage: SafeUrl  = '';

	imageFile: File = null;
	localUrl: any = null;
	showPreview = false;
	lastFileName: string = null;
	image: SafeUrl = null;
	disabled: boolean = true;
	dialogReference: any;
	hasImage = false;
	@Input() url: string = null;
	@Input() hiddenDelete: boolean = false;
	@Input() label: string;
	@Input() rounded = false;
	@Input() hiddenPreview = false;
	@Input() freeCropper = false;
	@Input() previewPosition: 'top' | 'top-right' | 'bottom' | 'bottom-right' | 'right' | 'low' | 'low-right' = 'top-right';
	@Input() aspectRatio = 16/9;
	@Input() model: any = null;
	@Input() onlyImg: boolean = false;
	@Input() downloadBtn: boolean = false;
	@Input() showError: boolean = false;
	@Output() fileChange = new EventEmitter<File>();
	@Output() imageChange = new EventEmitter<string>();
	@Input() fitMode: 'original' | 'cover' = 'cover';
	@ViewChild('cropper') cropperModal: TemplateRef<any>;

	containWithinAspectRatio = false;
	transform: ImageTransform = {
		translateUnit: 'px'
	};

	allowMoveImage = false;
	canvasRotation = 0;
	
	constructor(
		private toasterService: ToasterService,
		private uploadImageService: UploadImageService,
		private sanitizer: DomSanitizer,
		private dialog: MatDialog,
	) {
	}

	ngOnInit(): void {
		if(!isNullOrUndefined(this.url)){
			this.hasImage = true;
		}
	}

	removeImage() {
		this.localUrl = null;
		this.url = null;
		this.hasImage = false;
		this.imageChange.emit(null);
		this.fileChange.emit(null);
		this.dialogReference.close(true);
	}

	fileChangeEvent(event: Event): void {
		const files = (event as any).target.files as FileList;
		const maxSizeInBytes = environment.fileImageSize * 1024 * 1024; // 5 MB
		const allowedImageTypes = ['image/jpeg', 'image/png', 'image/gif'];

		if (files.length === 0) {
		  return;
		}

		const file = files[0];

		if (!allowedImageTypes.includes(file.type)) {
		  this.toasterService.show("general.only_image_files_are_allowed", ToasterTypeEnum.ERROR);
		  return;
		}

		if (file.size > maxSizeInBytes) {
		  this.toasterService.show("general.file_size_exceeds_the_limit", ToasterTypeEnum.ERROR);
		  return;
		}

		this.showError = false;
		this.dialogReference = this.dialog.open(this.cropperModal, {
		  width: '50vw',
		  height: 'auto',
		  maxHeight: '90vh',
		  disableClose: true,
		});
		this.imageChangedEvent = event;
		this.fileChange.emit(file);
		this.lastFileName = file.name;
		const fileSizeInKilobytes = file.size / 1024;
		const unit = 'KB';
		this.uploadImageService.isSizeInMegabytes(fileSizeInKilobytes, unit);
	  }

	async imageCropped(event: ImageCroppedEvent) {
		const file = new File([event.blob], this.lastFileName, { type: event.blob.type });
		let urlSafe: any = this.sanitizer.bypassSecurityTrustUrl(event.objectUrl);
		this.localUrl = urlSafe.changingThisBreaksApplicationSecurity;
		this.hasImage = true;
		this.imageFile = file;
		if(!isNullOrUndefined(this.localUrl)){
			this.disabled = false;
		}
	}

	closeModal() {
		this.url = null;
		this.imageChange.emit(this.localUrl);
		this.fileChange.emit(this.imageFile);
		this.disabled = true;
		this.dialogReference.close(true);
	}

	async downloadImg(){
		await this.uploadImageService.downloadFile(this.url ?? this.localUrl, this.model.fileName);
	}



}
